import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import {changePage, showAlert} from 'redux/modules/app';
import {startCurrentUserVerificationRequest} from 'redux/modules/users';
import SettingsAccountReadOnly from 'modules/legacy/js/components/settings-account-readonly';

function mapDispatchToProps(dispatch) {
  return bindActionCreators({startCurrentUserVerificationRequest, changePage, showAlert}, dispatch);
}

export default connect(null, mapDispatchToProps)(SettingsAccountReadOnly);
